import { IdSchemaEnum } from "../../../Configurator/Enums/IdSchemaEnum";
import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import {
  ErrorHandlingModeType,
  IdSchemaType,
} from "../../../Configurator/Types/ConfiguratorTypes";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import FansUnitedSdkException from "../../../Exception/FansUnitedSdkException";
import StandardFansUnitedException from "../../../Exception/StandardFansUnitedException";
import { ErrorMessages } from "../../../Global/Messages/Messages";

export default class MappingValidator {
  private errorHandlingModel: ErrorHandlingModeType = null;

  constructor(config: SDKConfigurationModel) {
    this.errorHandlingModel = config.errorHandlingMode;
  }

  public validate = (
    ids: string[],
    inputProvider: IdSchemaType,
    outputProvider: IdSchemaType
  ) => {
    if (!ids || !Array.isArray(ids) || ids.length === 0) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_IDS,
        ErrorMessages.INVALID_OR_EMPTY_IDS
      );
    }

    if (
      !inputProvider ||
      (inputProvider !== IdSchemaEnum.NATIVE &&
        inputProvider !== IdSchemaEnum.ENETPULSE &&
        inputProvider !== IdSchemaEnum.SPORTAL_365 &&
        inputProvider !== IdSchemaEnum.SPORTRADAR &&
        inputProvider !== IdSchemaEnum.API_FOOTBALL)
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_INPUT_PROVIDER,
        ErrorMessages.INVALID_PROVIDER
      );
    }

    if (
      !outputProvider ||
      (outputProvider !== IdSchemaEnum.NATIVE &&
        outputProvider !== IdSchemaEnum.ENETPULSE &&
        outputProvider !== IdSchemaEnum.SPORTAL_365 &&
        outputProvider !== IdSchemaEnum.SPORTRADAR &&
        outputProvider !== IdSchemaEnum.API_FOOTBALL)
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_OUTPUT_PROVIDER,
        ErrorMessages.INVALID_PROVIDER
      );
    }

    if (inputProvider === outputProvider) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_OUTPUT_PROVIDER,
        ErrorMessages.INVALID_OUTPUT_PROVIDER
      );
    }
  };

  private throwException = (code: number, status: string, message: string) => {
    if (this.errorHandlingModel === "standard") {
      throw new StandardFansUnitedException(code, status, message);
    }

    throw new FansUnitedSdkException(code, status, message);
  };
}
